import { gql } from '__generated__'

export const CREATE_GUEST_SESSION = gql(`
  mutation createGuestSession($data: CreateGuestSessionInput) {
    createGuestSession(data: $data) {
      id
      userId
      claimedAt
      expiresAt
    }
  }
`)
